/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

/**
 * Consumption status enumeration.
 */
export type ConsumptionStatus = typeof ConsumptionStatus[keyof typeof ConsumptionStatus];


export const ConsumptionStatus = {
  not_started: 'not_started',
  in_progress: 'in_progress',
  completed: 'completed',
} as const;
